import { useState, useContext, useEffect } from 'react';
import { PeopleOutlined } from '@material-ui/icons';
import { LazyObjectiveAccordion } from './LazyObjectiveAccordion';
import { OrgConfigContext } from '../../context/OrgConfigContextProvider';

export const TeamObjectiveCardList = ({
  teamName,
  objectives,
  krsLoader,
  isExpanded,
  onExpandChange,
  initialKrs,
  }) => {
    const [location, setLocation] = useState('');
  const { isSemEnabled } = useContext(OrgConfigContext);
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const refSrc = searchParams.get('location');
    setLocation(refSrc || '');
  }, []);
  return (
    <>
      <div className="m-details-teams-okr-name">
        <PeopleOutlined/><p>{teamName}</p>
      </div>
      {objectives.map((obj) => (
        <LazyObjectiveAccordion
          context={{
            location,
            locationDetail: 'Meeting_Conversation_Team_Objectives',
            semEnabled: isSemEnabled,
          }}
          obj={{ ...obj, daysLeft: obj.daysLeft.replace('days', '') }} // remove 'days' from the data so the component doesn't repeat it
          krsLoader={krsLoader}
          externalExpanded={isExpanded(obj.id)}
          handleChange={onExpandChange}
          initialKrs={initialKrs}
        />
      ))}
    </>
  );
};
 